<template>
  <v-layout row wrap class>
    <v-flex xs12>
      <v-container ma-0>
        <div class="display-1 primary--text">{{$t('company.footer.about.title')}}</div>
        <v-divider class="primary divider-custom-height my-1"></v-divider>
        <div class="my-4">
          <div class="pb-1 custom_font_size secondary--text" v-for="(term) in terms" :key="term.text" v-html="term.text"></div>
        </div>
      </v-container>
    </v-flex>
  </v-layout>
</template>
<script>
import i18n from "@/i18n";
export default {
  name: "About",
  data: () => ({
    terms: [
      { text: i18n.t("company.footer.about.point_1") },
      { text: i18n.t("company.footer.about.point_2") },
      { text: i18n.t("company.footer.about.point_3") },
      { text: i18n.t("company.footer.about.point_4") },
      { text: i18n.t("company.footer.about.point_5") },
      { text: i18n.t("company.footer.about.point_6") },
      { text: i18n.t("company.footer.about.point_7") },
      { text: i18n.t("company.footer.about.point_8") },
      { text: i18n.t("company.footer.about.point_9") },
      { text: i18n.t("company.footer.about.point_10") }
    ]
  })
};
</script>